<ng-container *hasPermission="['ORGANIZATION_CONFIG_READ','ORGANIZATION_CONFIG_ALL', 'SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Località - <b>{{detail_title}}</b></h2>
        </div>
        <form name="localityForm" #f="ngForm" (ngSubmit)="onSubmit(f)">

            <app-city-autocomplete idPrefix="locality" [showProvince]="false" [showPostalCode]="false"
                [city]="locality.cityName" (cityChange)="locality.cityName = $event" [cityId]="locality.cityId"
                (cityIdChange)="locality.cityId = $event">
            </app-city-autocomplete>

            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="localityKey" class="form-label">Chiave località(BO)</label>
                    <input type="text" class="form-control" id="localityKey" name="localityKey" ngModel
                        [(ngModel)]="locality.localityKey" required />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="gdpData" class="form-label">Dati GdP</label>
                    <input type="text" class="form-control" id="gdpData" name="gdpData" ngModel
                        [(ngModel)]="locality.gdpData" />
                </div>
                <div class="col-md-6 mb-3">
                    <label for="prefectData" class="form-label">Dati Prefettura</label>
                    <input type="text" class="form-control" id="prefectData" name="prefectData" ngModel
                        [(ngModel)]="locality.prefectData" />
                </div>
            </div>

            <div class="d-flex justify-content-end  align-items-center mt-3 gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="back()">Indietro</button>
                <ng-template [hasPermission]="['ORGANIZATION_CONFIG_DELETE', 'ORGANIZATION_CONFIG_ALL','SAFESTREET_ADMIN']">
                    @if (locality.id !== undefined) {
                    <button type="button" (click)="confirmDelete()" class="btn btn-danger">
                        Elimina
                    </button>
                    }
                </ng-template>
                <ng-template [hasPermission]="['ORGANIZATION_CONFIG_CREATE', 'ORGANIZATION_CONFIG_UPDATE', 'ORGANIZATION_CONFIG_ALL','SAFESTREET_ADMIN']">
                    <button type="submit" class="btn btn-primary">
                        Salva
                    </button>
                </ng-template>
            </div>
        </form>
        <app-confirm-alert [confirmationMessage]="confirmationMessage" [showConfirmationModal]="showConfirmationModal"
            (modalConfirm)="delete()" (modalCancel)="cancelDelete()">
        </app-confirm-alert>
    </div>
</ng-container>
